export function tongji(event, type, data) {
  return
  const language = JSON.parse(localStorage.getItem('poprun_language'));
  var params = {
    event_name: 'xiaomi poprun',//	活动名称
    page: '',// （加粗为新增）	页面url后缀
    page_type: '',// （新增，具体看02页面模块管理）	页面类型
    tipB: '',//	tipB
    tipC: '',//	tipC
    tipC1: '',//	tipC1
    tipD: '',//	tipD
    tipE: '',//	tipE
    tip: '',//	tip
    source_location: '',//	访问来源
    open_url: '',//	此按钮，点开的模块跳转链接
    open_page: '',//	下一页的page_type
    button_name: '',//	按钮名称
    module_name: '',//	模块名称
  };
  params = {
    ...params,
    ...data
  }
  var user_mid = localStorage.getItem('user_mid');
  var userParams = {
    platform: 'pc',//	平台app、pc、m
    site: language != null ? language.code : 'global',//	站点/区域 国别
    user_mid: user_mid != null ? user_mid : undefined,//	用户ID(当前事件操作用户的ID)
    user_level: undefined,//	操作用户等级
  }
  if (browser.versions.mobile) {
    userParams.platform = 'm';
  }
  gtag('set', 'user_properties', userParams);
  gtag(event, type, params)// 这个是设置这个事件相关属性
}


//默认调用参数
/*this.$tongji('event','view',{
  page:'/index',// （加粗为新增）	页面url后缀
  page_type:'poprun_home',// （新增，具体看02页面模块管理）	页面类型
  tipB:'',//	tipB
  tipC:'',//	tipC
  tipC1:'',//	tipC1
  tipD:'',//	tipD
  tipE:'',//	tipE
  tip:'',//	tip
  source_location:'',//	访问来源
  open_url:'',//	此按钮，点开的模块跳转链接
  open_page:'',//	下一页的page_type
  button_name:'',//	按钮名称
  module_name:'',//	模块名称
});*/
